module.exports = __webpack_public_path__ + "static/media/ayuntVila.be20b5a2.webp";